import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import studentsApi from '../../../../api/students';
import { DEFAULT_PROFILE_PIC } from '../../../../assets/icons';
import { IStudent } from '@wot/typings';

export default function StudentProfile() {
  const { student_id } = useParams();
  const [student, setStudent] = useState<IStudent>();
  useEffect(() => {
    if (!student_id) {
      return;
    }
    studentsApi
      .getStudentProfile(student_id)
      .then((data) => {
        setStudent(data);
      })
      .catch((err) => err);
  }, []);

  if (!student) {
    return <p>Not Found FOund</p>;
  }

  return (
    <div className="w-full h-full flex flex-col gap-7 bg-neutralBlue2 p-4">
      <div className="w-11/12 mx-auto flex flex-col gap-5">
        <div className="w-1/4 flex items-center justify-center">
          <img
            src={student?.profilePic === '' ? DEFAULT_PROFILE_PIC : student?.profilePic}
            alt="User Profile Pic"
            className="h-24 w-24 rounded-full object-cover"
          />
        </div>
        <div className="flex flex-row gap-16">
          <div className="flex flex-col gap-5 text-base text-neutralGray1 font-medium">
            <span>
              <p>Name</p>
            </span>
            <span>
              <p>Phone Number</p>
            </span>
            <span>
              <p>Email ID</p>
            </span>
            <span>
              <p>Area, Street</p>
            </span>
            <span>
              <p>Town/City</p>
            </span>
            <span>
              <p>State</p>
            </span>
            <span>
              <p>Pincode</p>
            </span>
            <span>
              <p>Country</p>
            </span>
          </div>
          <div className="flex flex-col gap-5 text-base text-neutralGray3 font-medium">
            <span>
              <p>{student.name}</p>
            </span>
            <span>
              <p>{student.phoneNumber}</p>
            </span>
            <span>
              <p>{student.email}</p>
            </span>
            <span>
              <p>{student.address?.area}</p>
            </span>
            <span>
              <p>{student.address?.town}</p>
            </span>
            <span>
              <p>{student.address?.state}</p>
            </span>
            <span>
              <p>{student.address?.pincode}</p>
            </span>
            <span>
              <p>{student.address?.country}</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
